import React, { useEffect, createElement } from 'react';
export const MetaPixel = () => {
  useEffect(() => {
    const pixelId = '1252242806993118';
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    // Initialize fbq queue
    const w = window as any;
    if (!w.fbq) {
      const fbq: any = function () {
        // eslint-disable-next-line prefer-rest-params
        fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
      };
      w.fbq = fbq;
      if (!w._fbq) w._fbq = fbq;
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      fbq.queue = [];
    }
    // Inject the fbevents script safely
    const scriptId = 'meta-pixel-script';
    if (!document.getElementById(scriptId)) {
      const t = document.createElement('script');
      t.id = scriptId;
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const target = document.head || document.body || document.documentElement;
      if (target) target.appendChild(t);
    }
    try {
      w.fbq('init', pixelId);
      w.fbq('track', 'PageView');
    } catch (e) {
      // Silently ignore — pixel will retry on next mount
    }
  }, []);
  return null;
};